"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _ExitToApp = _interopRequireDefault(require("@mui/icons-material/ExitToApp"));
var _useDmsLogoffTabs = require("../../Hooks/useDmsLogoffTabs");
var _DmsModal = require("../DmsModal/DmsModal");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsButton = require("../DmsButton/DmsButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsLogout Component
 *
 * This component renders a logout button that, when clicked, opens a confirmation modal.
 * If the user confirms, the session is cleared, and the user is logged out.
 *
 * @component
 * @example
 * return <DmsLogout />;
 */
const DmsLogout = () => {
  const logoff = (0, _useDmsLogoffTabs.useDmsLogoffTabs)();
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    color: "inherit",
    onClick: handleOpenModal,
    "aria-label": _reactIntlUniversal.default.get("Logout").d("Logout")
  }, /*#__PURE__*/_react.default.createElement(_ExitToApp.default, null)), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: showModal,
    onClose: handleCloseModal,
    closeWithIconOnly: true
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: _reactIntlUniversal.default.get("Logout").d("Logout"),
    onClose: handleCloseModal
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, _reactIntlUniversal.default.get("dmslogoutConfirmation").d("Are you sure you want to log out?")), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "error",
    text: _reactIntlUniversal.default.get("yes").d("Yes"),
    onClick: logoff
  }), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    text: _reactIntlUniversal.default.get("cancel").d("Cancel"),
    onClick: handleCloseModal
  }))));
};
exports.DmsLogout = DmsLogout;
DmsLogout.propTypes = {};